<template>
  <div class="my-summarized-index-div1">
    <table style="width: 100%;" cellspacing="0" cellpadding="0">
      <tr height="50px">
        <td>
          <div class="my-summarized-index-div2">
            <span class="my-summarized-index-span1">公司简介</span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="my-summarized-index-td2">
          <span v-html="content" class="my-summarized-index-span2"></span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import {
    getInfoDesc,
  } from '@/api/InfoDesc.js'

  export default {
    name: "SummarizedIndex",
    data() {
      return {
        content: "",
      };
    },
    components: {},
    methods: {

    },
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    },
    created() {
      getInfoDesc('info/getDesc?type=2', this)
      this.$store.state.activeIndex = "2";
    }
  }
</script>

<style>
  .my-summarized-index-div1 {
    width: 1200px;
    margin: 0 auto;
  }

  .my-summarized-index-span1 {
    font-size: 25px;
    font-weight: bold;
    color: white;
  }

  .my-summarized-index-div2 {
    width: 260px;
    background: royalblue;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .my-summarized-index-td2 {
    border: 0px hidden;
    background: white;
    text-align: left;
  }

  .my-summarized-index-span2 {
    text-indent: 2em;
    font-size: 18px;
  }

  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/summarized/SummarizedIndex.vue